"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";

const Logo = () => {
  const router = useRouter();

  return (
    <>
      <Image
      onClick={() => router.push("/")}
      className="block cursor-pointer"
      src="/images/seozast-logo.png"
      height={150}
      width={150}
      alt="Logo"
      priority
    />
    </>
  );
};

export default Logo;
